/**
 * The address a visitor asked for before being sent to sign in, if it is safe
 * to go back to it.
 *
 * Değer adres çubuğundan geliyor — yani saldırgan tarafından yazılabilir.
 * Bu yüzden allow-list: yalnızca bu uygulamanın içindeki bir yol takip edilir.
 *
 * Everything else returns '/'. An open redirect through a real sign-in on our
 * own domain is worth more to a phisher than a fake login page, because the
 * address bar says us the whole way.
 */
/**
 * The value to hand to /login as `returnUrl`, or null when there is nothing
 * worth carrying.
 *
 * Two callers reach sign-in — authGuard, for an address typed while signed
 * out, and logout(), for a session that lapsed on a page. Both have to answer
 * the same question, and answering it twice is how the two drift apart.
 */
export function returnUrlFor(currentUrl: string | null | undefined): string | null {
  if (!currentUrl || currentUrl === '/') return null;
  if (currentUrl.split('?')[0] === '/login') return null;
  return currentUrl;
}

export function safeReturnUrl(raw: string | null | undefined): string {
  if (!raw) return '/';

  // A path, and only a path. `//evil.example` and `/\evil.example` are other
  // hosts to a browser while looking like paths to a startsWith('/') check.
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return '/';

  // A control character is never legitimate in a URL the router will follow.
  // eslint-disable-next-line no-control-regex
  if (/[ -]/.test(raw)) return '/';

  // Returning to the sign-in form after signing in reads as a failed login.
  const path = raw.split('?')[0];
  if (path === '/login') return '/';

  return raw;
}
